import configureStore from './configureStore'

export const { persistor, store } = configureStore()
